// extracted by mini-css-extract-plugin
export default {"wrapper":"RevenueWidget_wrapper__BVkKL","itemWrapper":"RevenueWidget_itemWrapper__FnAkY","header":"RevenueWidget_header__4Hz3V","value":"RevenueWidget_value__YNfKJ"};